'use client'

import { LightHeaderNav } from './nav'
import { Logo } from '../logo'
import { ButtonLink } from '../../../sotano-kit/primitives/button'
import { Container } from '~/sotano-kit/primitives/container'
import { UserNav } from './user-nav'
import { MobileMenu } from './mobile'
import { useSelectedLayoutSegments } from 'next/navigation'
import { HeaderMiddleLinksFragment } from './links'

export const LightHeader = ({
  headerLinks,
}: {
  headerLinks: HeaderMiddleLinksFragment[]
}) => {
  const [selectedLayoutSegment] = useSelectedLayoutSegments()
  const isInMktPage = !selectedLayoutSegment
    ? true
    : [
        'manifesto',
        'docs',
        'home',
        'changelog',
        'blog',
        'templates',
        'pricing',
      ].includes(selectedLayoutSegment)

  return (
    <header className="sticky top-0 z-50 h-12 w-full justify-between rounded-b-3xl bg-dark-base shadow-header">
      <Container
        size="large"
        className="grid grid-cols-2 lg:grid-cols-[250px_1fr_250px] items-center lg:gap-x-3 h-full !px-4 md:!px-8"
      >
        <ButtonLink
          unstyled
          href={isInMktPage ? '/home' : '/'}
          className="pointer-events-auto relative max-w-max cursor-pointer"
        >
          <h2 className="sr-only">BaseHub Logo</h2>

          {/* Logo for tablet & desktop */}
          <Logo className="w-18 md:w-[92px]" />
        </ButtonLink>

        <div className="hidden lg:flex justify-center h-full">
          <LightHeaderNav headerLinks={headerLinks} />
        </div>

        <div className="flex justify-end">
          <UserNav themeSwitcher={!isInMktPage} />
          <div className="lg:hidden flex justify-end ml-1">
            <MobileMenu headerLinks={headerLinks} />
          </div>
        </div>
      </Container>
    </header>
  )
}
